module.exports = __webpack_public_path__ + "img/ico-right.92954476.svg";